import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import CheckBoxField from '../../../components/common/CheckBoxField';
import Preloader from '../../../components/common/Preloader';
import { getConsents, isDetailsPending } from '../../../modules/account/selectors';
import FormMessage from '../../FormMessage';
import Translation from '../../i18n/Translation';
import { consentsSaveRequest } from '../../settings/MarketingPreferences/actions';
import { viewEnter } from '../actions';

export class LoginConsents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      marketing: !!props.consents.marketing
    };
    this.toggleConsent = this.toggleConsent.bind(this);
    this.submitConsents = this.submitConsents.bind(this);
  }

  componentWillMount() {
    this.props.viewEnter();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      marketing: !!nextProps.consents.marketing
    });
  }

  toggleConsent(name, checked) {
    this.setState({ [name]: checked });
  }

  submitConsents() {
    const { saveConsents } = this.props;

    saveConsents({
      marketing: !!this.state.marketing
    }, 'login');
  }

  render() {
    const { checkingState } = this.props;

    if (checkingState) {
      return (
        <div className="login-consents">
          <div className="login-consents__preloader">
            <Preloader>
              <Translation section="linkingAccounts" label="checking" />
            </Preloader>
          </div>
        </div>
      );
    }

    const { marketing } = this.state;

    return (
      <div className="login-consents">
        <div className="login-consents__header">
          <div className="container--fixed">
            <FormMessage className="login-consents__form-message" />
            <h2 className="login-consents__title">William Hill and Your Data</h2>
            <p className="login-consents__description">
              Some of the rules are changing around how William Hill stores and uses your data.
            </p>
            <p className="login-consents__description">
              As part of this change we'd like to ask you whether you would still like to receive
              marketing communications from us.
            </p>
          </div>
        </div>
        <div className="login-consents__form">
          <div className="container--fixed">
            <CheckBoxField
              id="marketing"
              className="login-consents__checkbox-field"
              checked={!!marketing}
              onChange={this.toggleConsent}
            >
              By ticking this box you agree to receive direct marketing about William Hill’s
              gambling services, free bets and other promotions. You can opt-out at any time.
            </CheckBoxField>
            <Button className="login-consents__button" onClick={this.submitConsents}>
              Continue
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

LoginConsents.propTypes = {
  consents: PropTypes.object.isRequired,
  checkingState: PropTypes.bool,
  viewEnter: PropTypes.func.isRequired,
  saveConsents: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  viewEnter,
  saveConsents: consentsSaveRequest
};

const mapStateToProps = state => ({
  checkingState: isDetailsPending(state),
  consents: getConsents(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginConsents);
